(function(){
  if (window.__mlBlocksInit) { window.__mlBlocksInit(); return; }
  function fmt(cents, format){
    if(!format){ return '$'+(cents/100).toFixed(2); }
    var n = (cents/100);
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/); var key = m ? m[1] : 'amount';
    function d(num, prec, t, dec){ var s=num.toFixed(prec).split('.'); s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,t); return s.join(dec); }
    var v = key==='amount_no_decimals'?d(n,0,',','.'):key==='amount_with_comma_separator'?d(n,2,'.',','):key==='amount_no_decimals_with_comma_separator'?d(n,0,'.',','):key==='amount_with_apostrophe_separator'?d(n,2,"'",'.'):d(n,2,',','.');
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function init(){
    document.querySelectorAll('.ml-cart-count:not([data-init])').forEach(function(el){
      el.setAttribute('data-init','1');
      var min=parseInt(el.dataset.min)||5, max=parseInt(el.dataset.max)||20;
      var num=el.querySelector('.ml-cart-count__num');
      function roll(){ num.textContent = Math.floor(Math.random()*(max-min+1))+min; }
      roll(); setInterval(roll, 9000);
    });
    document.querySelectorAll('.ml-qb:not([data-init])').forEach(function(root){
      root.setAttribute('data-init','1');
      var data={}; try{ data=JSON.parse(root.querySelector('.ml-qb__variants').textContent); }catch(e){}
      var formId=root.dataset.formId, qtyInput=root.querySelector('.ml-qb__qty');
      var tiers=[].slice.call(root.querySelectorAll('.ml-qb__tier'));
      function currentVariant(){
        var form=document.getElementById(formId); var idInput=form && form.querySelector('[name="id"]');
        var id=idInput ? parseInt(idInput.value) : null;
        var list=data.variants||[]; for (var i=0;i<list.length;i++){ if(list[i].id===id) return list[i]; }
        return list[0];
      }
      function render(){
        var v=currentVariant(); if(!v) return;
        if (v.img) root.querySelectorAll('[data-variant-thumb] img').forEach(function(im){ im.src=v.img; im.removeAttribute('srcset'); });
        tiers.forEach(function(t){
          var q=parseInt(t.dataset.qty)||1, dsc=parseFloat(t.dataset.disc)||0;
          var fin=Math.round(v.price*q*(100-dsc)/100), cmpUnit=Math.max(v.compare||0, v.price), cmp=cmpUnit*q;
          var p=t.querySelector('[data-role=price]'); if(p) p.textContent=fmt(fin,data.money_format);
          var c=t.querySelector('[data-role=compare]'); if(c){ c.textContent=fmt(cmp,data.money_format); c.style.display = cmp>fin?'':'none'; }
          var sv=t.querySelector('[data-role=save]'); if(sv){ sv.textContent=fmt(cmp-fin,data.money_format); sv.parentNode.style.display = cmp>fin?'':'none'; }
        });
      }
      function select(t){
        tiers.forEach(function(x){ x.classList.toggle('is-active', x===t); var r=x.querySelector('input'); if(r) r.checked = (x===t); });
        qtyInput.value = t.dataset.qty || 1;
        var q=parseInt(t.dataset.qty)||1;
        root.querySelectorAll('.ml-addon').forEach(function(a){
          var ff=parseInt(a.dataset.freeFrom)||0, free=ff>0 && q>=ff, pr=a.querySelector('.ml-addon__price'), ck=a.querySelector('.ml-addon__check');
          a.classList.toggle('is-free', free); if(ck){ ck.disabled=free; if(free) ck.checked=false; else if(a.dataset.pre==='1' && !a.dataset.touched) ck.checked=true; if(!ck.dataset.mlT){ ck.dataset.mlT='1'; ck.addEventListener('change', function(){ a.dataset.touched='1'; }); } }
          if(pr) pr.textContent = free ? 'FREE' : pr.dataset.price;
        });
      }
      tiers.forEach(function(t){ t.addEventListener('click', function(){ select(t); }); });
      var active = root.querySelector('.ml-qb__tier.is-active') || tiers[0];
      if (active) select(active);
      document.addEventListener('change', function(){ setTimeout(render, 60); });
      document.addEventListener('variant:change', function(){ setTimeout(render, 60); });
      render();

      var up=root.querySelector('.ml-qb__upsell'), chk=null, qEl=null;
      if (up){
        qEl=up.querySelector('.ml-qb__upsell-qty'); chk=up.querySelector('.ml-qb__upsell-input');
        up.querySelectorAll('[data-step]').forEach(function(b){ b.addEventListener('click', function(){
          var n=Math.max(1, (parseInt(qEl.textContent)||1)+parseInt(b.dataset.step)); qEl.textContent=n; chk.checked=true;
        }); });
      }
      root.querySelectorAll('.ml-qb__vars select').forEach(function(sel){
        sel.addEventListener('change', function(){ sel.dataset.touched='1'; });
        sel.addEventListener('click', function(e){ e.stopPropagation(); var t=sel.closest('.ml-qb__tier'); if(t && !t.classList.contains('is-active')) select(t); });
      });
      function syncSelects(){
        var v=currentVariant(); if(!v) return;
        if (v.img) root.querySelectorAll('[data-variant-thumb] img').forEach(function(im){ im.src=v.img; im.removeAttribute('srcset'); });
        root.querySelectorAll('.ml-qb__vars select').forEach(function(sel){ if(!sel.dataset.touched) sel.value=String(v.id); });
      }
      document.addEventListener('change', function(e){ if(!root.contains(e.target)) setTimeout(syncSelects, 80); });
      document.addEventListener('variant:change', function(){ setTimeout(syncSelects, 80); });
      document.addEventListener('submit', function(e){
        var form=e.target;
        if (!form || !form.getAttribute || form.getAttribute('id') !== formId || form.dataset.mlDone) return;
        var act=root.querySelector('.ml-qb__tier.is-active');
        var sels=act ? [].slice.call(act.querySelectorAll('.ml-qb__vars select')) : [];
        var items=[];
        if (up && chk && chk.checked) items.push({id: parseInt(up.dataset.variantId), quantity: parseInt(qEl.textContent)||1});
        var softProps={};
        root.querySelectorAll('.ml-addon').forEach(function(a){ var ck=a.querySelector('.ml-addon__check'); if(!a.dataset.variantId && a.classList.contains('is-free')){ softProps[a.dataset.prop]='Included FREE'; return; } if(!ck || !ck.checked) return; if(!a.dataset.variantId){ softProps[a.dataset.prop]= a.classList.contains('is-free') ? 'Included FREE' : 'Yes'; return; } if(!a.classList.contains('is-free')) items.push({id: parseInt(a.dataset.variantId), quantity: 1}); });
        Object.keys(softProps).forEach(function(k){ var h=form.querySelector('input[data-ml-prop="'+k+'"]'); if(!h){ h=document.createElement('input'); h.type='hidden'; h.setAttribute('data-ml-prop',k); h.name='properties['+k+']'; form.appendChild(h);} h.value=softProps[k]; });
        form.querySelectorAll('input[data-ml-prop]').forEach(function(h){ if(!(h.getAttribute('data-ml-prop') in softProps)) h.remove(); });
        var idIn=form.querySelector('[name="id"]'), origId=idIn ? idIn.value : null;
        if (sels.length > 1 && idIn){
          idIn.value = sels[0].value; qtyInput.value = 1;
          var agg={}; sels.slice(1).forEach(function(s){ agg[s.value]=(agg[s.value]||0)+1; });
          Object.keys(agg).forEach(function(k){ items.push({id: parseInt(k), quantity: agg[k]}); });
        }
        var addUrl=(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
        if (root.dataset.afterAdd === 'checkout' && idIn) {
          e.preventDefault(); e.stopImmediatePropagation();
          var all=items.slice();
          var mainItem={id: parseInt(idIn.value), quantity: parseInt(qtyInput.value)||1}; if(Object.keys(softProps).length) mainItem.properties=softProps; all.unshift(mainItem);
          var btn=form.querySelector('[type="submit"]'); if (btn){ btn.setAttribute('aria-disabled','true'); btn.classList.add('loading'); }
          fetch(addUrl, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: all})})
            .then(function(r){
              if (r.ok) { window.location.href = root.dataset.checkoutUrl || '/checkout'; return; }
              throw new Error('add failed');
            })
            .catch(function(){
              if (btn){ btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
              if (idIn && origId) idIn.value = origId;
              if (act) qtyInput.value = act.dataset.qty || 1;
              form.dataset.mlDone='1';
              setTimeout(function(){ form.requestSubmit ? form.requestSubmit() : form.submit(); setTimeout(function(){ delete form.dataset.mlDone; }, 1500); }, 0);
            });
          return;
        }
        if (!items.length) return;
        e.preventDefault(); e.stopImmediatePropagation();
        fetch(addUrl, {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items: items})
        }).catch(function(){}).then(function(){
          form.dataset.mlDone='1';
          setTimeout(function(){ if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true})); }, 0);
          setTimeout(function(){
            delete form.dataset.mlDone;
            if (act) qtyInput.value = act.dataset.qty || 1;
            if (idIn && origId) idIn.value = origId;
          }, 1500);
        });
      }, true);
    });
  }
  window.__mlBlocksInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

(function(){
  function fmtD(d){var m=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()];var n=d.getDate();var s=(n%10==1&&n!=11)?'st':(n%10==2&&n!=12)?'nd':(n%10==3&&n!=13)?'rd':'th';return m+' '+n+s;}
  function add(n){var d=new Date();d.setDate(d.getDate()+n);return d;}
  function run(){document.querySelectorAll('.ml-tl:not([data-init])').forEach(function(el){
    el.setAttribute('data-init','1');
    var r=(el.dataset.ready||'1,2').split(',').map(Number), v=(el.dataset.deliver||'7,12').split(',').map(Number);
    el.querySelector('[data-kind=order]').textContent=fmtD(new Date());
    el.querySelector('[data-kind=ready]').textContent=fmtD(add(r[0]))+' - '+fmtD(add(r[1]));
    el.querySelector('[data-kind=deliver]').textContent=fmtD(add(v[0]))+' - '+fmtD(add(v[1]));
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  document.addEventListener('shopify:section:load',run);
})();
